import React, { useEffect, useState, useRef, useCallback } from "react";

import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import { apiCall } from "../../services/api-service.js";
import ReactPaginate from "react-paginate";
import DeleteModal from "../common/DeleteModal";
import ListFooter from "../common/ListFooter.jsx";
import ReportButton from "../common/ReportButton.jsx";
import { useExcelActions } from "../../hooks/useExcelActions";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import edit from "../../Assets/svg/edit.svg";
import dt from "../../Assets/svg/delete.svg";
import { useGlobal } from "../../GlobalContext.js";

const Maillist = ({ children }) => {
  const { rolePermissionList } = useGlobal();

  const navigate = useNavigate();
  const [mailConfigList, setMailConfigList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10); // or any default value
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [status, setStatus] = useState("All");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }

  useEffect(() => {
    getListData(searchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemOffset, itemsPerPage]);

  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * itemsPerPage;
      setItemOffset(newOffset); // Not event.selected
    },
    [itemsPerPage]
  );
  const [deleteId, setDeleteId] = useState(null);
  const deleteTeam = (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  };

  const deleteApi = async () => {
    if (deleteId == null) return;
    const response = await apiCall("delete", `email_config/${deleteId}`);
    if (response?.status === 200) {
      if (response.data?.success === true) {
        setDeleteId(null);
        setIsOpenDelete(false);
        getListData("");
      }
      setSnackbarMessage(response.data?.message ?? "");
      setSnackbarStatus(response.data?.success ?? false);
      handleSnackbarShow();
    }
  };
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    // A new search starts from the first page. If already on page 1, fetch
    // directly; otherwise reset the offset and let the itemOffset effect fetch.
    if (itemOffset === 0) {
      getListData(term, 0);
    } else {
      setItemOffset(0);
    }
  }, 1000);
  const getListData = async (term, skip = itemOffset) => {
    const response = await apiCall("get", "email_config", null, {
      params: {
        limit: itemsPerPage,
        skip,
        search: term,
        status,
      },
    });
    if (response?.status === 200 && response.data?.success === true) {
      const totalPages = response.data.total_pgs ?? 0;
      setTotalCount(response.data.total_rec ?? 0);
      setPageCount(totalPages);
      setMailConfigList(response.data.configs ?? []);

      // Snap back to the last page if the current page is now out of range.
      const currentPage = Math.floor(skip / itemsPerPage);
      if (currentPage > totalPages) {
        setItemOffset(totalPages * itemsPerPage);
      }
    }
  };

  const { reportLoading, downloadReport } = useExcelActions("mail", getListData, {
    setSnackbarMessage,
    setSnackbarStatus,
    handleSnackbarShow,
  }, "mail_configurations");

  return (
    <Container
      fluid
      style={{ width: "100%", padding: "0px", fontFamily: "Satoshi" }}
    >
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // height: "100vh",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div className="maincontent3">
              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ gap: "12px" }}>
                  <div>
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "20px",
                        lineHeight: "22px",
                        color: "#212129",
                      }}
                    >
                      Email Configuration
                    </span>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#8790A1",
                      }}
                    >
                      Manage your emails and create new configured email here
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                 
                  {checkPermission("Mail configuration", "create_permission") && (
                    <Link to="/mail/add" className="nav-link">
                      <button
                        style={{
                          height: "40px",
                          borderRadius: "100px",
                          padding: "8px 16px 8px 16px",
                          gap: "8px",
                          backgroundColor: "#6929E2",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "none",
                        }}
                      >
                        <p
                          style={{
                            margin: "0",
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "14px",
                            lineHeight: "18.9px",
                            color: "#FFFFFF",
                          }}
                        >
                          + Create Email
                        </p>
                      </button>
                    </Link>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "16px",
                }}
                className="mb-3"
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "14px",
                      lineHeight: "22px",
                      color: "#212129",
                      margin: "0",
                    }}
                  >
                    Total emails: {totalCount}
                  </p>
                </div>

                <div
                  style={{
                    height: "40px",
                    gap: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "16px",
                  }}
                >
                  <div>
                    <input
                      type="search"
                      placeholder="Search..."
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                        handleSearch(event.target.value);
                      }}
                      style={{
                        width: "300px",
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.5px solid #E5E5E5",
                        padding: "14px 16px 14px 16px",
                        gap: "6px",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  </div>
                   <ReportButton
                    loading={reportLoading}
                    onClick={() => downloadReport({ status, search: searchTerm })}
                  />
                </div>
              </div>

              <div
                className="d-flex flex-column py-3"
                style={{ borderRadius: "8px", backgroundColor: "#FFFFFF" }}
              >
                <div
                  className="py-3 px-4 d-flex col-12"
                  style={{ backgroundColor: "#F2F2F2" }}
                >
                  <div
                    className="col-3"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Email
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    SMTP Server
                  </div>
                  <div
                    className="col-1"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    SMTP port
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Start
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Last Read
                  </div>
                  <div
                    className="col-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "13px",
                      color: "#212129",
                    }}
                  >
                    Status
                  </div>
                </div>
                <div>
                  {mailConfigList.map((item, index) => (
                    <div
                      key={item.id ?? "table-list" + index}
                      style={{ position: "relative", cursor: "pointer" }}
                    >
                      <div
                        className="py-2 px-3 d-flex col-12"
                        style={{
                          backgroundColor: "#FFFFFF",
                          borderBottom: "0.6px solid #D4DDE7",
                        }}
                      >
                        <div
                          className="col-3"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.email}
                        </div>
                        <div
                          className="col-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.server}
                        </div>
                        <div
                          className="col-1"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.port}
                        </div>
                        <div
                          className="col-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.start}
                        </div>
                        <div
                          className="col-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          {item.last_read}
                        </div>
                        <div
                          className="col-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#212129",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span>
                              {" "}
                              {item.status === true
                                ? "🟢 Active"
                                : "🔴 Inactive"}
                            </span>

                            {checkPermission(
                              "Mail configuration",
                              "edit_permission"
                            ) && (
                              <div
                                onClick={() => {
                                  navigate("/mail/add", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  marginLeft: "16px",
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  gap: "10px",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <img
                                  src={edit}
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}

                            {checkPermission(
                              "Mail configuration",
                              "delete_permission"
                            ) && (
                              <div
                                onClick={() => {
                                  deleteTeam(item.id);
                                }}
                                style={{
                                  marginLeft: "8px",
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  gap: "10px",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <img
                                  src={dt}
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}
                          </div>
                          {/* <select style={{ fontWeight: '500', fontSize: '14px', color: '#212129', background: 'transparent', border: 'none', outline: 'none', cursor: 'pointer' }}>
                                            <option value="active">🟢 Active</option>
                                            <option value="inactive">🔴 Inactive</option>
                                        </select> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>{" "}
                <ListFooter
                  itemsPerPage={itemsPerPage}
                  onItemsPerPageChange={(n) => {
                    setItemOffset(0);
                    setItemsPerPage(n);
                  }}
                  pagination={
                    <ReactPaginate
                      previousLabel={
                        <img src={lar} className="ar3" alt="previous" />
                      }
                      nextLabel={<img src={rar} className="ar3" alt="next" />}
                      breakLabel={"..."}
                      pageCount={pageCount + 1}
                      forcePage={Math.min(
                        Math.floor(itemOffset / itemsPerPage),
                        pageCount
                      )}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <DeleteModal
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteApi}
        title="Delete Mail Config"
        message="You won’t able to access your config after deleting. Are you sure want to delete?"
      />
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
                                                                        <strong className="mr-auto">Snackbar Title</strong>
                                                                      </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default Maillist;
